import { REFRESH } from '@app/store/types/refresh'

export function refreshAction() {
  return {
    type: REFRESH,
    payload: null,
  }
}
